<template>
  <section>
    <v-layout row wrap>

      <v-layout class="mt-5 mb-4" justify-end >
        <v-flex xs9 class="text-xs-left">
          <div class="title-secondary">Registro de evaluaciones</div>
        </v-flex>
        <v-flex xs2 class="text-xs-left">
          <v-btn color="primary" @click="volver()"><v-icon>arrow_back</v-icon>Volver</v-btn>
        </v-flex>
      </v-layout>

      <v-flex xs10 offset-xs1>
         <v-layout row wrap style="
            border-right: 2px solid #00897b;
            border-bottom: 2px solid #00897b;
            border-left: 2px solid #00897b;"
          >
          <v-flex xs12 style="background-color: #00897b;">
            <p class="text-xs-center py-2 px-2 white--text mb-0">DATOS CURSO</p>
          </v-flex>
          <v-flex xs4 style="border-right: 2px solid #00897b;
          border-bottom: 2px solid #00897b;">
            <p class="my-2 ml-2"><strong>Curso:</strong></p>
          </v-flex>
          <v-flex xs8 style="border-bottom: 2px solid #00897b;">
            <p class="my-2 ml-2">{{ curso.cource_title }}</p>
          </v-flex>
          <v-flex xs4 style="border-right: 2px solid #00897b;
          border-bottom: 2px solid #00897b;">
            <p class="my-2 ml-2"><strong>Profesor:</strong></p>
          </v-flex>
          <v-flex xs8 style="border-bottom: 2px solid #00897b;">
            <p class="my-2 ml-2">{{ curso.autor.nombre }}{{ curso.autor.apellido }}</p>
          </v-flex>
          <v-flex xs4 style="border-right: 2px solid #00897b">
            <p class="my-2 ml-2"><strong>Descripción:</strong></p>
          </v-flex>
          <v-flex xs8>
            <p class="my-2 ml-2">{{ curso.cource_description }}</p>
          </v-flex>
          </v-layout>

          <div class="mt-5">
              <v-tabs v-model="active">
                <v-tabs-bar class="accent" dark>
                  <v-tabs-item
                    v-for="tab in tabs"
                    :key="tab"
                    :href="'#' + tab"
                    ripple
                  >
                    <span class="white--text">{{ tab }}</span> 
                  </v-tabs-item>
                  <v-tabs-slider style="height: 10%;" color="secondary"></v-tabs-slider>
                </v-tabs-bar>
                <v-tabs-items style="
                  border-right: 2px solid #00897b;
                  border-bottom: 2px solid #00897b;
                  border-left: 2px solid #00897b;    
                  padding-bottom: 10px;"
                >
                  <v-tabs-content
                    v-for="tab in tabs"
                    :key="tab"
                    :id="tab"
                  >
                    <v-card flat class="mb-5">
                      
                    <v-flex xs11 offset-xs1 class=""  v-if="tab === 'Evaluaciones'" >
                      <v-layout class="mt-5 mb-3">
                        <v-flex xs7 class="text-xs-left">
                          <p class="subtitle-ev">Evaluaciones Ingresadas</p>
                        </v-flex>
                        <v-flex xs4 class="text-xs-right">
                          <v-btn 
                            color="accent white--text" 
                            @click.native.stop="dialogEditCalificaciones = true; addEvaluation = true"
                            @click="editCalificacion(miembros)">
                            Añadir Evaluación
                          </v-btn>
                        </v-flex>
                      </v-layout>
                      <v-flex xs11>
                        <v-data-table
                          v-bind:headers="headers"
                          :items="calificaciones"
                          hide-actions
                          class="mb-5 brAccent blAccent"
                          no-data-text="No hay evaluaciones registradas en este curso.">
                          <template slot="items" slot-scope="props">
                            <td class="text-xs-right" style="
                              border-right: 1px solid #00897b;
                              border-bottom: 1px solid #00897b;"
                            >{{ props.index + 1}}</td>
                            <td class="text-xs-right border-td">{{ props.item.qualification_descripcion }}</td>
                            <td class="text-xs-right border-td">{{ props.item.qualification_weighing }} %</td>
                            <td class="text-xs-right border-td">{{ props.item.qualification_surrender_date }}</td>
                            <td class="text-xs-right" style="border-bottom: 1px solid #00897b;">
                        <v-btn flat icon color="red lighten-2" @click="deleteCalificacion(props.item.id)">
                            <v-icon>delete</v-icon>
                          </v-btn>
                          <v-btn flat icon color="blue" @click.native.stop="dialogEditCalificaciones = true; addEvaluation = false;" @click="setCurrentCalificacion(props.item)" >
                            <v-icon>create</v-icon>
                          </v-btn>
                          </td>
                          </template>
                        </v-data-table>
                      </v-flex>
                    </v-flex>
                    

                      <v-flex xs10 offset-xs1 class=""  v-if="tab === 'Ingreso  Calificaciones'">
                        <v-flex v-if="calificaciones && calificaciones.length > 0">
                          <v-flex xs8 offset-xs2 class="mt-4">
                            <v-select
                              v-bind:items="calificaciones"
                              single-line
                              label="Select"
                              bottom
                              item-text="qualification_descripcion"
                              item-value="id"
                              hint="Seleccione una Evaluación"
                              persistent-hint 
                              v-model="calificacion_id"
                              v-on:change="loadmiembrosDelCurso()"
                            ></v-select>
                          </v-flex>

                          <v-flex xs12>
                            <template>
                              <v-form>
                            <v-card flat>
                              <v-layout justify-between align-center class="mt-2 mb-3">
                                <v-flex xs3>
                                  <p class="mt-4 subtitle-ev">Lista Alumnos</p>
                                </v-flex>
                                <v-flex xs6 class="text-xs-left">
                                  <v-text-field
                                    append-icon="search"
                                    label="Buscar"
                                    single-line
                                    hide-details
                                    v-model="search"
                                  ></v-text-field>
                                </v-flex>
                                <v-flex v-if="!editQualifications" xs3 class="text-xs-right">
                                  <v-btn class="mt-4" color="accent white--text" @click="editCalificacion(miembros)">
                                    {{`Editar Calificaciónes`}}
                                  </v-btn>
                                </v-flex>
                                <v-flex v-if="editQualifications" xs3 class="text-xs-right">
                                  <v-btn class="mt-4" color="primary white--text" @click="editCalificacion(miembros)">
                                    {{'Guardar Calificaciónes'}}
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                              <v-data-table
                                v-bind:headers="headersIgresoNotas"
                                v-bind:items="miembros"
                                v-bind:search="search"
                                style="border: 1px solid #00897b"
                                no-data-text="No se encontrarón registros.">
                                <template slot="items" slot-scope="props">
                                  <td class="text-xs-center  ">{{ props.index + 1}}</td>
                                  <td class="text-xs-center  ">
                                    <v-avatar>
                                       <img :src="props.item.avatar"/>
                                    </v-avatar>
                                  </td>
                                  <td class="text-xs-right">{{ props.item.nombre}} {{ props.item.apellido }}</td>
                                  <td class="text-xs-right ">{{ props.item.email}} </td>
                                  <td class="text-xs-right" style="width: 200px;">
                                    <v-text-field
                                      v-if="!editQualifications"
                                      name="input-1-3"
                                      single-line
                                      v-model="miembros[props.index].qualification"
                                      prepend-icon="create"
                                      :label="miembros[props.index].qualificationEstudent"
                                      hint="Edite la nota"
                                      disabled>
                                    </v-text-field>
                                    <v-text-field
                                      v-if="editQualifications"
                                      name="input-1-3"
                                      single-line
                                      v-model="miembros[props.index].qualification"
                                      prepend-icon="create"
                                      :label="miembros[props.index].qualificationEstudent"
                                      hint="Edite la nota">
                                    </v-text-field>
                                  </td>
                                </template>
                              </v-data-table>
                            </v-card>
                            </v-form>
                          </template>
                            
                          </v-flex>
                        </v-flex>
                        <v-flex v-if="!calificaciones || calificaciones.length == 0">
                          <v-layout justify-center>
                            <div class="mt-5 text-no-data">
                              {{`No hay evaluaciones registradas en este curso.`}}
                            </div>
                          </v-layout>
                        </v-flex>
                      </v-flex>

                       <v-flex xs10 offset-xs1 v-if="tab === 'Ver Calificaciones'">
                        <div v-if="calificaciones && calificaciones.length > 0"  class="pb-5">
                          <p class="mt-5 subtitle-ev mb-4">Listado Calificaciones</p>
                           <div class="py-2" style="width: 10%; float: left;background-color: #00897b; text-align: center;"><p class="white--text mb-0">Nº</p></div>
                           <div class="py-2"  style="width: 25%; float: left;background-color: #00897b; text-align: center;" ><p class="white--text mb-0">NOMBRE</p></div>
                           <div style="width: 50%; float: left;background-color: #00897b; text-align: center;">
                             <div v-for="(calificacion, index) in calificaciones">
                              <div class="py-2"  :style="tablaStyle" style="float: left; background-color: #00897b; text-align: center;" >
                                <p class="white--text mb-0"> {{ calificacion.qualification_weighing }} %  </p>
                              </div>
                             </div>
                           </div>
                           <div class="py-2"  style="width: 15%; float: left;background-color: #00897b; text-align: center;"><p class="white--text mb-0">PROMEDIO</p></div>

                          <div style="margin-bottom: 10px" v-for="(miembro, index) in miembrosNotas">
                           <div style="width: 10%; float: left;border-left: 1px solid #00897b
  border-right: 1px solid #00897b;
  border-bottom: 1px solid #00897b;"><p class="mb-0 py-2 text-xs-center">{{ index + 1 }}</p></div>
                           <div style="width: 25%; float: left;
  border-right: 1px solid #00897b;
  border-bottom: 1px solid #00897b;margin-left: border-bottom: 1px solid #00897b;" ><p class="mb-0 py-2 pl-2 text-xs-center">{{ miembro.user.nombre }} {{ miembro.user.apellido }}</p></div>
                           <div style="width: 50%; float: left;
  border-bottom: 1px solid #00897b;">
                             <div v-for="notas in miembro.member_qualification" >
                               <div class="py-2" :style="tablaStyle" style="float: left; border-right: 1px solid #00897b;text-align: center">{{ notas.qualificationEstudent }}</div>
                             </div>
                           </div>
                           <div style="width: 15%; float: left;
  border-right: 1px solid #00897b;
  border-bottom: 1px solid #00897b;"><p class="mb-0 py-2 text-xs-center">{{ miembro.promedio }}</p></div>

        
                          </div>
                        </div>
                        <v-flex v-if="!calificaciones || calificaciones.length == 0">
                          <v-layout justify-center>
                            <div class="mt-5 text-no-data">
                              {{`No hay evaluaciones registradas en este curso.`}}
                            </div>
                          </v-layout>
                        </v-flex>
                       </v-flex>
                    </v-card>
                  </v-tabs-content>
                </v-tabs-items>
              </v-tabs>
          </div>
      </v-flex>

    </v-layout>

    <v-dialog v-model="dialogEditCalificaciones"  max-width="40%" >
  <v-card class="bordes ma-0">
      <v-toolbar flat dark color="orange darken-4">
        <v-flex xs11 offset-xs1 >
          <v-card-title class="white--text pt-0 pb-0 headline">
            {{`${(addEvaluation) ? 'Añadir' : 'Editar'} Evaluación`}}
          </v-card-title>
        </v-flex>
        <v-spacer></v-spacer>
        <v-btn flat icon color="white" @click.native="dialogEditCalificaciones = false">
          <v-icon >close</v-icon>
        </v-btn>
      </v-toolbar>

    <v-form 
      ref="formEv"
      v-model="validEvForm"
      lazy-validation>
      <v-card-text>
        <v-container grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 >
               <div >
                        <v-layout row >
                          <v-flex xs3>
                            <v-subheader><strong>Descripción:</strong></v-subheader>
                          </v-flex>
                          <v-flex xs9>
                            <v-text-field
                              v-if="!addEvaluation"
                              name="input-1"
                              label="Descripción de la evaluación"
                              v-model="currentCalificacion.qualification_descripcion"
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                            <v-text-field
                              v-if="addEvaluation"
                              name="input-1"
                              label="Descripción de la evaluación"
                              v-model="calificacion.qualification_descripcion"
                              required
                              :rules="[rules.required]"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                          <v-flex xs3>
                            <v-subheader class="mt-2">
                              <strong>{{`Ponderación:\n(Maximo un decimal Ej: 33.3)`}}</strong>
                            </v-subheader>
                          </v-flex>
                          <v-flex xs3>
                            <v-text-field
                              v-if="!addEvaluation"
                              name="input-1"
                              label="Ponderación"
                              v-model="currentCalificacion.qualification_weighing"
                              required
                              suffix="%"
                              :rules="[rules.required, rules.double]"
                            ></v-text-field>
                             <v-text-field
                              v-if="addEvaluation"
                              name="input-1"
                              label="Ponderación"
                              v-model="calificacion.qualification_weighing"
                              required
                              suffix="%"
                              :rules="[rules.required, rules.double]"
                            ></v-text-field>
                          </v-flex>
                        </v-layout>
                        <v-layout row>
                        <v-flex xs3>
                          <v-subheader><strong>Contenido:</strong></v-subheader>
                        </v-flex>
                        <v-flex xs9>
                          <v-text-field
                            v-if="!addEvaluation"
                            name="input-7-1"
                            label="Ingrese el contenido"
                            multi-line
                            v-model="currentCalificacion.qualification_content"
                          ></v-text-field>
                          <v-text-field
                            v-if="addEvaluation"
                            name="input-7-1"
                            label="Ingrese el contenido"
                            multi-line
                            v-model="calificacion.qualification_content"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs3>
                          <v-subheader><strong>Observación:</strong></v-subheader>
                        </v-flex>
                        <v-flex xs9>
                          <v-text-field
                            v-if="!addEvaluation"
                            name="input-7-1"
                            label="Ingrese la observacion"
                            multi-line
                            v-model="currentCalificacion.qualification_observation"
                          ></v-text-field>
                          <v-text-field
                            v-if="addEvaluation"
                            name="input-7-1"
                            label="Ingrese la observacion"
                            multi-line
                            v-model="calificacion.qualification_observation"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                      <v-layout row>
                        <v-flex xs3>
                          <v-subheader><strong>Fecha Evacluación:</strong></v-subheader>
                        </v-flex>
                        <v-flex xs4>
                          <v-menu
                            v-if="!addEvaluation"
                            lazy
                            :close-on-content-click="false"
                            v-model="menuEdit"
                            transition="scale-transition"
                            offset-y
                            full-width
                            :nudge-right="40"
                            max-width="290px"
                            min-width="290px"
                          >
                            <v-text-field
                              slot="activator"
                              label="Fecha en formato M/D/A "
                              v-model="dateFormattedEditar"
                              prepend-icon="event"
                              @blur="dateEditar = parseDateEditar(dateFormattedEditar)"
                            ></v-text-field>
                            <v-date-picker v-model="dateEditar" @input="dateFormattedEditar = formatDateEditar($event)" no-title scrollable actions>
                              <template slot-scope="{ save, cancel }">
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn flat color="primary" @click="cancel">Cancelar</v-btn>
                                  <v-btn flat color="primary" @click="save">Seleccionar</v-btn>
                                </v-card-actions>
                              </template>
                            </v-date-picker>
                          </v-menu>
                          <v-menu
                            v-if="addEvaluation"
                            lazy
                            :close-on-content-click="false"
                            v-model="menu"
                            transition="scale-transition"
                            offset-y
                            full-width
                            :nudge-right="40"
                            max-width="290px"
                            min-width="290px"
                          >
                            <v-text-field
                              slot="activator"
                              label="Fecha en formato M/D/A "
                              v-model="dateFormatted"
                              prepend-icon="event"
                              @blur="date = parseDate(dateFormatted)"
                            ></v-text-field>
                            <v-date-picker v-model="date" @input="dateFormatted = formatDate($event)" no-title scrollable actions>
                              <template slot-scope="{ save, cancel }">
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn flat color="primary" @click="cancel">Cancelar</v-btn>
                                  <v-btn flat color="primary" @click="save">Seleccionar</v-btn>
                                </v-card-actions>
                              </template>
                            </v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                      <v-spacer></v-spacer>
                      </div> 
            </v-flex>   
        </v-layout>
      </v-container>
      <small class="ml-3">*Campos Obligatorios</small>
    </v-card-text>
    <v-card-actions class="pb-4 mr-2">
      <v-spacer></v-spacer>
      <v-btn class="mr-3" color="orange darken-2" outline @click.native="dialogEditCalificaciones = false" >Cancelar</v-btn>
      <v-btn
        v-if="!addEvaluation && validEvForm" 
        color="orange darken-2 white--text" 
        @click="editCalificacionBasico(currentCalificacion.id, currentCalificacion)">
        Guardar Cambios
      </v-btn>
      <v-btn
        v-if="!addEvaluation && !validEvForm" 
        color="orange darken-2 white--text" 
        @click="editCalificacionBasico(currentCalificacion.id, currentCalificacion)"
        disabled>
        Guardar Cambios
      </v-btn>
      <v-btn
        v-if="addEvaluation && validEvForm" 
        color="orange darken-2 white--text" 
        @click="submitCalificacion(calificacion)">
        Añadir Evaluación
      </v-btn>
      <v-btn
        v-if="addEvaluation && !validEvForm" 
        color="orange darken-2 white--text" 
        @click="submitCalificacion(calificacion)"
        disabled>
        Añadir Evaluación
      </v-btn>
    </v-card-actions>
  </v-form>
</v-card>
</v-dialog>
    
  </section>
     
</template>
<script>
import { courceService } from '@/services/Cource.service'
import { getQualificationPerCourseService } from '@/services/Calificacion/GetQualificationPerCourse.service'
import { calificacionService } from '@/services/Calificacion/Calificacion.service'
import { getMemberQualificationService } from '@/services/Miembro/GetMemberQualification.service'
import { updateMembersQualificationService } from '@/services/Miembro/UpdateMembersQualification.service'
import { getUsersInCourseService } from '@/services/Miembro/GetUsersInCourses.service'
export default {
  data () {
    return {
      curso: {
        autor: {
          nombre: '',
          apellido: ''
        }
      },
      editQualifications: false,
      validEvForm: false,
      idCurso: 0,
      tabs: ['Evaluaciones', 'Ingreso  Calificaciones', 'Ver Calificaciones'],
      active: null,
      calificacion: {},
      calificaciones: [],
      date: null,
      dateEditar: null,
      dateFormatted: null,
      dateFormattedEditar: null,
      menu: false,
      menuEdit: false,
      menuEdit2: false,
      miembros: [],
      miembrosNotas: [],
      calificacion_id: 0,
      headers: [
        { text: 'Nº', value: 'n', class: 'white--text accent text-xs-center', sortable: false },
        { text: 'EVALUACIÓN', value: 'evaluacion', class: 'white--text accent text-xs-center', sortable: false },
        { text: 'PONDERACIÓN %', value: 'ponderacion', class: 'white--text accent text-xs-center', sortable: false },
        { text: 'FECHA EVALUACIÓN', value: 'fecha', class: 'white--text accent text-xs-center', sortable: false },
        { text: 'ACCIONES', value: 'acciones', class: 'white--text accent text-xs-center', sortable: false }
      ],
      headersIgresoNotas: [
        { text: 'Nº', value: 'n', class: 'white--text text-xs-center accent', sortable: false },
        { text: 'IDENTIFICACIÓN', value: 'identificacion', class: 'white--text accent text-xs-center', sortable: false },
        { text: 'NOMBRE', value: 'nombre', class: 'white--text text-xs-center accent', sortable: false },
        { text: 'EMAIL', value: 'email', class: 'white--text text-xs-center accent', sortable: false },
        { text: 'CALIFICACIÓN', value: 'ponderacion', class: 'white--text accent text-xs-center', sortable: false }
      ],
      tmp: '',
      search: '',
      pagination: {},
      cantidadEvaluaciones: 0,
      errorMessages: [],
      formHasErrors: false,
      dialogEditCalificaciones: false,
      addEvaluation: false,
      currentCalificacion: {},
      rules: {
        double: (value) => {
          const pattern = /^[1-7]{1}[0-9]{0,1}(\.{1}([0-9]){1})$/
          return pattern.test(value) || 'Formato ingresado invalido'
        },
        nota: (value) => {
          const pattern = /^[1-7]{1}(\.{1}([0-9]){1})$/
          return pattern.test(value) || 'Valor invalido'
        },
        required: (value) => !!value || 'Este campo es requerido'
      }
    }
  },
  mounted () {
    let vm = this
    vm.idCurso = vm.$route.params.id
    vm.loadCurso()
    vm.loadCalificaciones()
    vm.loadmiembrosDelCursoNotas()
  },
  watch: {
    name () {
      this.errorMessages = []
    }
  },
  methods: {
    loadCurso () {
      let vm = this
      courceService.getById(vm.idCurso).then(data => {
        vm.curso = data.body
      })
    },
    loadCalificaciones () {
      let vm = this
      getQualificationPerCourseService.getById(vm.idCurso).then(data => {
        vm.calificaciones = data.body
        vm.cantidadEvaluaciones = (vm.calificaciones).length
        vm.calificacion_id = data.body[0].id
        vm.loadmiembrosDelCurso(vm.calificacion_id)
      })
    },
    loadmiembrosDelCurso (calificacion) {
      let vm = this
      vm.$nextTick(function () {
        getMemberQualificationService.getById(vm.calificacion_id).then(data => {
          vm.miembros = data.body
        })
      })
    },
    loadmiembrosDelCursoNotas () {
      let vm = this
      getUsersInCourseService.getById(vm.idCurso).then(data => {
        vm.miembrosNotas = data.body
      })
    },
    validateEvForm () {
      this.$refs.formEv.validate()
    },
    submitCalificacion (data) {
      this.validateEvForm()
      if (this.validEvForm) {
        let vm = this
        data.qualification_surrender_date = vm.dateFormatted
        data.course_id = vm.idCurso
        calificacionService.save(data).then(data => {
          vm.calificaciones = data.body
          vm.cantidadEvaluaciones = (vm.calificaciones).length
        }, response => {
        })
        vm.calificacion = {}
        this.dialogEditCalificaciones = false
        this.resetForm()
      }
    },
    resetForm () {
      this.$refs.formEv.reset()
    },
    setCurrentCalificacion (calificacion) {
      let vm = this
      vm.currentCalificacion = calificacion
    },
    editCalificacion (calificacion) {
      if (this.editQualifications) {
        let vm = this
        updateMembersQualificationService.update(1, calificacion).then(data => {
          vm.calificaciones = data.body
        }, response => {})
        this.editQualifications = false
        this.dialogEditCalificaciones = false
      } else {
        this.editQualifications = true
        this.dialogEditCalificaciones = false
      }
    },
    editCalificacionBasico (id, calificacion) {
      this.validateEvForm()
      if (this.validEvForm) {
        let vm = this
        calificacion.qualification_surrender_date = vm.dateFormattedEditar
        calificacion.course_id = vm.idCurso
        calificacionService.update(id, calificacion).then(data => {
          vm.calificaciones = data.body
        }, response => {
        })
        this.dialogEditCalificaciones = false
        this.resetForm()
      }
    },
    deleteCalificacion (id) {
      let vm = this
      calificacionService.destroy(id).then(data => {
        vm.calificaciones = data.body
      }, response => {
      })
    },
    verCurso (id) {
      this.$router.push({name: 'ListCourses', params: {id: id}})
    },
    volver () {
      this.$router.back()
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${year}/${month}/${day}`
    },
    parseDate (date) {
      if (!date) {
        return null
      }
      const [month, day, year] = date.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    formatDateEditar (dateEditar) {
      if (!dateEditar) {
        return null
      }
      const [year, month, day] = dateEditar.split('-')
      return `${year}/${month}/${day}`
    },
    parseDateEditar (dateEditar) {
      if (!dateEditar) {
        return null
      }
      const [month, day, year] = dateEditar.split('/')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    }
  },
  computed: {
    tablaStyle: function () {
      var calculo = (100 / this.cantidadEvaluaciones)
      var string = calculo + '%'
      return { width: string }
    }
  }
}
</script>

<style scoped>
 .enlace {
    text-decoration:none;
  }
  .brAccent {
    border-right: 1px solid #00897b;
  }
  .blAccent {
    border-left: 1px solid #00897b;
  }
  .bbAccent {
    border-bottom: 1px solid #00897b;
  }
  .btAccent {
    border-top: 1px solid #00897b;
  }
  .btAddEvaluation {
    border: 3px solid red;
    align-self: 'center';
  }
  .text-no-data {
    font-size: 18px;
    font-weight: 300;
    letter-spacing: 0.5px;
  }
  .title-secondary {
    letter-spacing: 2.5px;
    color: #e64a19;
    font-size: 25px;
    font-weight: 500;
  }
  .title-head-table {
    font-size: 10px;
    font-weight: 700;
  }
  .border-td {
    border-right: 1px solid #00897b;
    border-bottom: 1px solid #00897b;
  }
  .subtitle-ev {
    font-size: 19px; 
    letter-spacing: 1.5px;
    font-weight: 500;
  }
  
  
</style>


// WEBPACK FOOTER //
// src/components/Calificacion/ShowQualification.vue